// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'create-deal-spinner',
    templateUrl: './create-deal-spinner.component.html',
    styleUrls: ['./create-deal-spinner.component.scss'],
})
export class CreateDealSpinnerComponent implements OnInit {
    getPhrase = ['Starting to Create Your Deal', 'Adding Documents to your Deal….this can take a few seconds', 'Almost Complete…'];

    constructor() {}

    ngOnInit(): void {
        this.changePhrase(this.getPhrase);
    }

    changePhrase(arr) {
        const phrase = document.getElementById('phrase');
        for (let i = 0; i < arr.length; i++) {
            // for each iteration console.log a word
            // and make a pause after it

            (function (i) {
                setTimeout(function () {
                    if (arr[i].length <= 0) {
                        arr = [''];
                    } else {
                        phrase.innerHTML = arr[i];
                    }
                }, 2500 * i);
            })(i);
        }
    }
}
